import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "PuaDetailsContainer": () => import("./components/PuaDetailsContainer.vue"),
    "PuaManagerContainer": () => import("./components/PuaManagerContainer.vue"),
    "PuaPlotsContainer": () => import("./components/PuaPlotsContainer.vue"),
    "PuaPlotSelectorContainer": () => import("./components/PuaPlotSelectorContainer.vue"),
    "PuaInterdictionsContainer": () => import("./components/PuaInterdictionsContainer.vue"),
    "PuaSpreadingContainer": () => import("./components/PuaSpreadingContainer.vue"),

    "PuaPlotSelectorTile": () => import("./components/tiles/PuaPlotSelectorTile.vue"),
    "PuaAnomalies": () => import("./components/tiles/PuaAnomalies.vue"),
    "PuaListTile": () => import("./components/tiles/PuaListTile.vue"),
    "PuaDetailsTile": () => import("./components/tiles/PuaDetailsTile.vue"),
    "PuaFarmBalanceTile": () => import("./components/tiles/PuaFarmBalanceTile.vue"),
    "PuaPlotListTile": () => import("./components/tiles/PuaPlotListTile.vue"),
    "PuaInterdictionsListTile": () => import("./components/tiles/PuaInterdictionsListTile.vue"),
    "PuaPrintTile": () => import("./components/tiles/PuaPrintTile.vue"),
    "PuaSpreadingListTile": () => import("./components/tiles/PuaSpreadingListTile.vue"),
    "PuaPlotInfoTile": () => import("./components/tiles/PuaPlotInfoTile.vue"),
    "PuaFertilizerTypeListTile": () => import("./components/tiles/PuaFertilizerTypeListTile.vue"),
    "PuaCatalogFertilizerSelector": () => import("./components/tiles/PuaCatalogFertilizerSelector.vue"),
    "PuaMapTile": () => import("./components/tiles/PuaMapTile.vue"),
    "PuaPlotElementsTile": () => import("./components/tiles/PuaPlotElementsTile.vue"),
    "PuaPlotElementsFertilizationsTile": () => import("./components/tiles/PuaPlotElementsFertilizationsTile.vue"),
    "PuaPlotElementsIrrigationsTile": () => import("./components/tiles/PuaPlotElementsIrrigationsTile.vue"),

    "PuaChart": {
            meta: {
            i18nDescrKey: "pua-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "PUA"
        },
        component: () => import("./components/chart/PuaChart.vue")
    }
};

export default globals;
